/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.BuyingRpc
 */

/**
 *  Request model for purchasing products and quantity packs.
 *  <p><b>IMPORTANT: Migrate to the new quantityPacks flow.</b> The legacy string-based API names
 *  for quantity packs are deprecated and will be removed.
 *  <p><b>NEW FLOW (Required for quantity packs):</b> Use {@code quantityPacks}
 *  <pre>{@code
 *  PurchaseRequest request = PurchaseRequest.builder()
 *    .setQuantityPacks(ImmutableSet.of(
 *      RequestedQuantity.builder()
 *        .setQuantityName(WireSafeEnum.of(QuantityName.CONTACTS))
 *        .setTotalQuantity(10)
 *        .setParentProductApiName("marketing-hub-starter")  // Required: specify parent product
 *        .build()
 *    ))
 *    .build();
 *  }</pre>
 *  <p><b>LEGACY FLOW (Deprecated - DO NOT USE):</b> String-based API names will be removed
 *  <pre>{@code
 *  PurchaseRequest request = PurchaseRequest.builder()
 *    .setProducts(ImmutableSet.of(
 *      RequestedProduct.builder()
 *        .setProductApiName("additional-marketing-contacts")  // Deprecated API name
 *        .setTotalQuantity(10)
 *        .build()
 *    ))
 *    .build();
 *  }</pre>
 *  <p><b>Migration required:</b>
 *  <ul>
 *    <li>NEW: Use {@link com.hubspot.merchandise.core.models.quantity.QuantityName} enum (e.g., CONTACTS, SALES_SEAT)</li>
 *    <li>NEW: Specify {@code parentProductApiName} in each {@link RequestedQuantity}</li>
 *    <li>OLD: String-based API names like "additional-marketing-contacts" will be removed</li>
 *  </ul>
 *  <p><b>Note:</b> The {@code products} field is used for parent/bundle products and defaults
 *  to an empty set if not specified. The {@code products} field is optional and only needed if you want to purchase parent products
 *  in the same request. Each quantity pack must specify its parent via the required
 *  {@code parentProductApiName} field in {@link RequestedQuantity}.
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const createPurchaseOrderRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'createPurchaseOrder',
  auth: 'app',
  fingerprint: '_XCnKSsip0TY5pstqgNqILbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsProductInventoryRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getSeatsProductInventory',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACHTP33O5UJ5JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInterstitialRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getInterstitial',
  auth: 'app',
  fingerprint: '_XCnKSsip0RV5ax64dYKApwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};